export default "__VITE_ASSET__oGfoeA2X__"